<template>
  <div
    :class="[$style.base, { [$style.smallScreen]: $screen === 's', [$style.mediumScreen]: $screen === 'm' }]"
    v-test="'sp-testimonial'"
  >
    <BaseText
      italic
      size="l"
      color="fixed"
    >
      {{ $t('register.salonized_pay.dashboard.testimonial.description', brandNamePay()) }}
    </BaseText>
    <div :class="$style.user">
      <img src="/img/salonized-pay/testimonial.png">
      <div :class="$style.name">
        <BaseText
          bold
          size="l"
          :mb="0.25"
          color="fixed"
        >
          {{ $t('register.salonized_pay.dashboard.testimonial.name') }}
        </BaseText>
        <BaseText color="fixed">
          {{ $t('register.salonized_pay.dashboard.testimonial.studio') }}
        </BaseText>
      </div>
    </div>
  </div>
</template>

<script
  setup
  lang="ts"
>
import { brandNamePay } from '@/helpers/brand-name';
</script>

<style
  lang="scss"
  module
>
.base {
  position: relative;
  border-radius: 8px;
  padding: $spacing * 2;
  max-width: 700px;
  width: 100%;
  background: linear-gradient(109deg, #e7fffa 16.06%, #be95ff 199.25%);
  box-shadow: 0px 0px 21px 0px rgba(0, 0, 0, 0.12);

  &:not(.smallScreen):not(.mediumScreen) {
    margin-bottom: $spacing * 6;
  }

  &.smallScreen, &.mediumScreen {
    margin-bottom: $spacing * 2;
  }
}

.user {
  display: flex;
  align-items: center;

  margin-top: $spacing * 1.5;
}

.name {
  margin-left: $spacing;
}
</style>
